import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { SoldItem } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class SoldItemService {
  // private http = inject(HttpClient)
  core = inject(CoreService)

  // public async getSoldItem(id): Promise<SoldItem> {
  //   return new SoldItem(
  //     await this.core.services.soldItem.getById(id, {
  //       id: null,
  //       name: null,
  //       // type: null,
  //       // color: null,
  //       // externalId: null,
  //     })
  //   )
  // }

  async getSoldItems(
    parameters: any = {
      page: 1,
      sort: 'id',
      direction: 'asc',
      filters: {},
    },
    schema: any = { id: null, name: null }
  ): Promise<{
    items: SoldItem[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.soldItem.getList(parameters, schema)
  }

  // createSoldItem(soldItem: Partial<SoldItem>, schema: SoldItem): Promise<SoldItem> {
  //     return this.core.services.soldItem.createWithTanstack(soldItem, schema)
  // }

  // updateSoldItem(soldItem: Partial<SoldItem>, schema: SoldItem): Promise<SoldItem> {y
  //     return this.core.services.soldItem.updateWithTanstack(soldItem, schema)
  // }

  // deleteSoldItem(soldItem: Partial<SoldItem>): Promise<SoldItem> {
  //   return this.core.services.soldItem.delete(SoldItem)
  // }
}
